import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/layouts/app.vue")),
  blinkproject: defineAsyncComponent(() => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/layouts/blinkproject.vue")),
  default: defineAsyncComponent(() => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/layouts/default.vue")),
  home: defineAsyncComponent(() => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/layouts/home.vue")),
  landing: defineAsyncComponent(() => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/layouts/landing.vue")),
  project: defineAsyncComponent(() => import("/Users/junyaoc/Documents/lab/oxb-web-5-cf/layouts/project.vue"))
}